import React from 'react';

export const HeroVisuals = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Animated Gradient Orbs */}
      <div className="absolute top-[10%] right-[15%] w-[400px] h-[400px] rounded-full bg-gradient-to-br from-[#5a7fa8]/20 to-[#4a9ead]/10 blur-[80px] animate-float-orb" />
      <div className="absolute bottom-[20%] left-[5%] w-[300px] h-[300px] rounded-full bg-gradient-to-tr from-[#c9a87c]/15 to-[#5a7fa8]/10 blur-[60px] animate-float-orb-reverse" />
      <div className="absolute top-[40%] right-[5%] w-[200px] h-[200px] rounded-full bg-gradient-to-bl from-[#4a9ead]/15 to-transparent blur-[50px] animate-pulse-slow" />
      
      {/* Floating Geometric Shapes */}
      <svg className="absolute top-[15%] right-[20%] w-32 h-32 animate-float-shape" viewBox="0 0 100 100" fill="none">
        <circle cx="50" cy="50" r="45" stroke="url(#gradient1)" strokeWidth="0.5" strokeDasharray="4 4" />
        <circle cx="50" cy="50" r="30" stroke="#5a7fa8" strokeWidth="0.5" opacity="0.4" />
        <circle cx="50" cy="50" r="15" stroke="#c9a87c" strokeWidth="1" opacity="0.6" />
        <defs>
          <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#5a7fa8" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#c9a87c" stopOpacity="0.3" />
          </linearGradient>
        </defs>
      </svg>

      <svg className="absolute bottom-[25%] right-[30%] w-24 h-24 animate-float-shape-reverse" viewBox="0 0 100 100" fill="none">
        <rect x="20" y="20" width="60" height="60" stroke="#5a7fa8" strokeWidth="0.5" opacity="0.3" transform="rotate(15 50 50)" />
        <rect x="30" y="30" width="40" height="40" stroke="#c9a87c" strokeWidth="0.5" opacity="0.4" transform="rotate(-10 50 50)" />
      </svg>

      <svg className="absolute top-[60%] left-[15%] w-20 h-20 animate-float-shape-slow" viewBox="0 0 100 100" fill="none">
        <polygon points="50,10 90,90 10,90" stroke="#4a9ead" strokeWidth="0.5" opacity="0.3" fill="none" />
        <polygon points="50,30 75,75 25,75" stroke="#c9a87c" strokeWidth="0.5" opacity="0.4" fill="none" />
      </svg>

      {/* Animated Lines */}
      <div className="absolute top-[30%] left-[25%] w-px h-32 bg-gradient-to-b from-transparent via-[#5a7fa8]/30 to-transparent animate-line-float" />
      <div className="absolute top-[50%] right-[25%] w-px h-24 bg-gradient-to-b from-transparent via-[#c9a87c]/30 to-transparent animate-line-float-reverse" />
      <div className="absolute top-[20%] left-[40%] w-24 h-px bg-gradient-to-r from-transparent via-[#4a9ead]/30 to-transparent animate-line-horizontal" />

      {/* Floating Dots */}
      <div className="absolute top-[25%] right-[35%] w-2 h-2 rounded-full bg-[#c9a87c] opacity-50 animate-float-dot" />
      <div className="absolute top-[45%] left-[30%] w-1.5 h-1.5 rounded-full bg-[#5a7fa8] opacity-40 animate-float-dot-reverse" />
      <div className="absolute bottom-[35%] right-[15%] w-2 h-2 rounded-full bg-[#4a9ead] opacity-40 animate-float-dot-slow" />
      <div className="absolute top-[70%] left-[20%] w-1 h-1 rounded-full bg-[#c9a87c] opacity-60 animate-float-dot" />
      <div className="absolute top-[15%] left-[35%] w-1.5 h-1.5 rounded-full bg-[#5a7fa8] opacity-30 animate-float-dot-reverse" />

      {/* Connecting Lines Network */}
      <svg className="absolute inset-0 w-full h-full opacity-20" viewBox="0 0 1920 1080" preserveAspectRatio="xMidYMid slice">
        <defs>
          <linearGradient id="lineGrad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#5a7fa8" stopOpacity="0" />
            <stop offset="50%" stopColor="#5a7fa8" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#5a7fa8" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path d="M1600,200 Q1400,400 1200,300" stroke="url(#lineGrad)" strokeWidth="1" fill="none" className="animate-path-draw" />
        <path d="M1700,500 Q1500,600 1400,400" stroke="url(#lineGrad)" strokeWidth="1" fill="none" className="animate-path-draw-delay" />
        <path d="M200,600 Q400,500 500,700" stroke="url(#lineGrad)" strokeWidth="1" fill="none" className="animate-path-draw" />
      </svg>

      {/* Radial Decorative Element - Top Right */}
      <div className="absolute -top-20 -right-20 w-[500px] h-[500px]">
        <svg viewBox="0 0 500 500" className="w-full h-full animate-rotate-very-slow">
          <circle cx="250" cy="250" r="200" stroke="#5a7fa8" strokeWidth="0.5" strokeDasharray="8 16" fill="none" opacity="0.15" />
          <circle cx="250" cy="250" r="150" stroke="#c9a87c" strokeWidth="0.5" strokeDasharray="4 8" fill="none" opacity="0.1" />
          <circle cx="250" cy="250" r="100" stroke="#4a9ead" strokeWidth="0.5" fill="none" opacity="0.1" />
        </svg>
      </div>

      {/* Subtle Particles */}
      {[...Array(8)].map((_, i) => (
        <div
          key={i}
          className="absolute w-1 h-1 rounded-full animate-twinkle"
          style={{
            left: `${20 + Math.random() * 60}%`,
            top: `${20 + Math.random() * 60}%`,
            backgroundColor: i % 2 === 0 ? '#c9a87c' : '#5a7fa8',
            opacity: 0.3 + Math.random() * 0.3,
            animationDelay: `${i * 0.5}s`,
            animationDuration: `${3 + Math.random() * 2}s`
          }}
        />
      ))}
    </div>
  );
};

export default HeroVisuals;
